import { SensitiveSettingsStorageBase } from '../../../classes/sensitive-settings-storage/sensitive-settings-storage-base.class';

export interface ISensitiveSettings {
    version: string;
    settingsStorage: SensitiveSettingsStorageBase;
    init(): void;
    updateSettingsInStorage(): void;
    setDefaultValues(): void;
    translateDefaultValues(): void;
    setAppSettings(settingsJsonString: string): void;
    getAppSettings(): ISensitiveSettings;
    getCurrentSettingsJSON(): string;
    loadSettingsFromStorage(): Promise<void>;
}
